import { useContext } from "react";

import { INotesStateContext, NotesStateContext } from "./NotesStateContext";

export const useNotesState = (): INotesStateContext => {
    return useContext(NotesStateContext);
};
